"use client";

import { Typography } from "@mui/material";
import ProductFeaturesView from "./ProductFeaturesView";
import ProductMobileScrollStrip from "./ProductMobileScrollStrip";

type Props = {
  features: string[];
};

export default function ProductMobileFeaturesStrip({ features }: Props) {
  if (!features.length) return null;

  return (
    <ProductMobileScrollStrip
      title="ویژگی‌ها"
      viewAllLabel="همه"
      framed
      items={(truncate) =>
        features.map((feature, index) => (
          <Typography
            key={index}
            variant="caption"
            noWrap
            sx={{
              display: "block",
              maxWidth: truncate ? 160 : undefined,
              px: 1,
              py: 0.75,
              borderRadius: 1.5,
              bgcolor: "grey.A100",
              fontSize: "0.7rem",
              lineHeight: 1.4,
              color: "grey.800",
            }}
          >
            {feature}
          </Typography>
        ))
      }
      sheetContent={<ProductFeaturesView features={features} alwaysExpanded />}
    />
  );
}
